export default __webpack_public_path__ + "static/media/PHONEPE1.561e2471.png";